import React from "react";
import browserIconPath from "./browser.svg";
import RequiredCookiesDetails from "../detail-texts/RequiredCookiesDetails";

const RequiredCookiesSection = ({ styles }) => (
  <div className="row">
    <div className="col-sm-1">
      <div className={styles.iconContainer}>
        <img
          className={styles.icon}
          src={browserIconPath}
          alt="required cookies icon"
        />
      </div>
    </div>
    <div className="col-sm-10">
      <div className={styles.textContainer}>
        <RequiredCookiesDetails styles={styles} />
      </div>
    </div>
    <div className="col-sm-1">
      <div className={styles.checkboxContainer}>
        <input
          type="checkbox"
          name="essentialCookies"
          checked="checked"
          disabled
        />
      </div>
    </div>
  </div>
);

export default RequiredCookiesSection;
